import * as types from "../constants/actionConstants";
import * as TEMPLATE from "../constants/templateConstants";
import {getList} from "./templateListActions";


export function setFilter(pageable, filter, templateType, templateMode) {

    let newFilter = filter;
    newFilter.pageNumber = 1;

    return (dispatch) => {
        // Note: user constant "TEMPLATE.FILTER[templateMode][templateType]" to get the name of the filter to update
        dispatch({type: types.SET_FILTER, filterName: TEMPLATE.FILTER[templateMode][templateType], filter: newFilter});
        if (templateType !== 'integrationLogs') dispatch(getList(pageable, filter, templateType, templateMode));
    };
}

export function clearFilter(pageable, filter, templateType, templateMode) {

    let newFilter = filter;

    newFilter.pageNumber = 1;
    newFilter.title = "";
    newFilter.nameQualifier = "";
    newFilter.updated = "";
    newFilter.updatedBy = "";
    newFilter.status = 0;
    newFilter.integrationType = "";
    newFilter.questionType = "ALL";
    newFilter.outstanding = false;
    newFilter.mode = ""; // used by the selectExistingFilter to know which templateType (category, group or question)
    newFilter.list = []; // used by the selectExistingFilter to store DDLB items
    newFilter.notType = ""
    newFilter.current = false
    newFilter.tags = []
    newFilter.templateKey = "" // Used by versions pages to get selected key
    newFilter.templateName = "" // Used by versions pages to get selected name
    newFilter.templateNameQualifier = "" // Used by versions pages to get selected nameQualifier
    newFilter.defaultActions = {}
    newFilter.ucid = ""
    newFilter.keyMetricIndex = 0
    newFilter.keyMetric = ""
    newFilter.questionnaire = ""


    return (dispatch) => {
        // Note: user constant "TEMPLATE.FILTER[templateMode][templateType]" to get the name of the filter to update
        dispatch({type: types.CLEAR_FILTER, filterName: TEMPLATE.FILTER[templateMode][templateType], filter: newFilter});
        if (templateType !== 'integrationLogs') dispatch(getList(pageable, filter, templateType, templateMode));
    };
}

